/* ============================================================
   RideWithPaws PDP — lightweight behaviour
   - gallery thumbnail switching
   - quantity steppers (sync the real <input name="quantity">)
   - sticky mobile add-to-cart reveal on scroll
   No dependencies. Safe to load more than once (self-guarded).
   ============================================================ */
(function () {
  if (window.__rwpPdpInit) return;
  window.__rwpPdpInit = true;

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-rwp-gallery-main]');
    if (!main) return;
    var mainImg = main.querySelector('img');
    root.querySelectorAll('[data-rwp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        if (mainImg && full) {
          mainImg.src = full;
          if (srcset) mainImg.srcset = srcset;
          mainImg.alt = alt;
        }
        root.querySelectorAll('[data-rwp-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty(qty) {
    var input = qty.querySelector('input[type="number"]');
    if (!input) return;
    var dec = qty.querySelector('[data-rwp-qty="dec"]');
    var inc = qty.querySelector('[data-rwp-qty="inc"]');
    var min = parseInt(input.min, 10) || 1;
    function clamp(v) { v = parseInt(v, 10); if (isNaN(v) || v < min) v = min; return v; }
    if (dec) dec.addEventListener('click', function () { input.value = clamp(input.value) - 1 < min ? min : clamp(input.value) - 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    if (inc) inc.addEventListener('click', function () { input.value = clamp(input.value) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    input.addEventListener('change', function () { input.value = clamp(input.value); });
  }

  /* ---------- Sticky mobile ATC ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-rwp-stickybar]');
    if (!bar) return;
    var sentinel = document.querySelector('[data-rwp-atc-sentinel]');
    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // show once the hero ATC has scrolled above the viewport
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && below);
      }, { threshold: 0 });
      io.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 600);
      }, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-rwp-gallery]').forEach(initGallery);
    document.querySelectorAll('.rwp-qty').forEach(initQty);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor injects/reloads a section
  document.addEventListener('shopify:section:load', boot);
})();
